import axios from 'axios';
import authHeader from './auth-header';

const API_URL = window.TELEMEDICINE_API_BASE_URL;

class UserService {
  findPatient(data) {
    return axios.post(`${API_URL}/patients/find`, data ,{ headers: {'Content-Type': 'application/json'} });
  }

  getDictionaries(data) {
    return axios.get(`${API_URL}/dictionaries`, { headers: authHeader(), params: data });
  }

  getTimeSlot(data) {
    return axios.get(`${API_URL}/timeslots`, { headers: authHeader(), params: data });
  }

  createAppointment(data) {
    return axios.post(`${API_URL}/appointment`, data ,{ headers: authHeader() });
  }

  sendConfirmation(data) {
    return axios.post(`${API_URL}/confirmphone/send`, data ,{ headers: authHeader() });
  }

  confirmCode(data) {
    return axios.post(`${API_URL}/confirmphone/confirm`, data ,{ headers: authHeader() });
  }

  getApprovedPatient(id) {
    return axios.get(`${API_URL}/appointment/${id}`, { headers: authHeader() });
  }
}

export default new UserService();
